"use client";

import { useEffect } from "react";

export function TimezoneInit() {
  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    const raw = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith("tz="))
      ?.slice(3);
    const current = raw ? decodeURIComponent(raw) : undefined;
    if (current === tz) return;
    const store = (
      window as unknown as {
        cookieStore?: {
          set: (init: {
            name: string;
            value: string;
            path?: string;
            sameSite?: "lax" | "strict" | "none";
            expires?: number | Date;
          }) => Promise<void>;
        };
      }
    ).cookieStore;
    if (store?.set) {
      void store.set({
        name: "tz",
        value: encodeURIComponent(tz),
        path: "/",
        sameSite: "lax",
        expires: Date.now() + 1000 * 60 * 60 * 24 * 365,
      });
    }
  }, []);

  return null;
}
